var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup159(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 61,
    viewBox: "0 0 50 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6364 28.8023C20.847 32.5516 22.4794 35.3545 22.6152 41.4058C23.056 38.2324 23.625 35.6313 24.4389 33.3829M34.4695 21.4303C32.1962 23.066 30.3574 24.592 28.8585 26.1864M28.8585 26.1864V22.3816M28.8585 26.1864C27.9279 27.1763 27.1282 28.1926 26.4369 29.2779M31.05 28.8023L26.4369 29.2779M26.4369 29.2779C25.6379 30.5322 24.9836 31.8786 24.4389 33.3829M21.3234 34.9851C21.5514 29.0401 16.6298 25.6064 11.4448 26.1864C11.6746 32.2643 15.7216 35.6986 21.6488 35.6986M24.4389 33.3829C22.3872 24.0462 28.5161 17.7898 37.661 17.6255C37.7199 27.7041 34.7799 33.0827 24.2935 33.7961",
    stroke: "#006D77",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6884 45.6859H33.3299M16.6884 45.6859L16.6883 48.1828M16.6884 45.6859C17.3722 39.7408 6.20194 42.1188 6.2019 24.0458C7.11377 14.5336 13.9527 7.39951 24.6671 6.92394C35.3816 6.44836 42.3311 15.1389 43.3604 24.0458C43.3604 40.9298 33.4825 41.1178 33.3299 45.6859M33.3299 45.6859V48.1828M18.284 52.5822H31.2782C32.9378 52.4049 33.356 51.796 33.3299 49.9664V48.1828M18.284 52.5822C17.1937 52.328 16.8287 51.9307 16.6883 50.6798V48.1828M18.284 52.5822V55.198C18.302 56.43 19.1959 56.8627 20.3357 56.8627C20.4271 56.8627 20.5549 56.8627 20.7136 56.8627M16.6883 48.1828H33.3299M31.5061 52.5822V55.198C31.4988 56.423 30.5942 56.8627 29.4544 56.8627C28.4059 56.8627 22.5348 56.8627 20.7136 56.8627M20.7136 56.8627C21.6588 61.0217 27.4934 61.1431 29.0892 56.8627",
    stroke: "#006D77",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.04603,
    height: 4.71341,
    rx: 1.02301,
    transform: "matrix(0.874492 -0.485039 0.454125 0.890938 34.4695 45.252)",
    fill: "#006D77"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.08881,
    height: 4.61744,
    rx: 1.04441,
    transform: "matrix(0.523282 -0.85216 0.831461 0.555583 42.2202 37.478)",
    fill: "#006D77"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.11388,
    height: 4.55934,
    rx: 1.05694,
    transform: "matrix(-0.00283434 -0.999996 0.999995 -0.00308422 45.4177 27.3628)",
    fill: "#006D77"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.08933,
    height: 4.61626,
    rx: 1.04466,
    transform: "matrix(-0.51779 -0.855508 0.835146 -0.550028 43.302 16.2446)",
    fill: "#006D77"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04683,
    height: 4.71166,
    rx: 1.02341,
    transform: "matrix(-0.869092 -0.494651 0.463476 -0.886109 36.2483 8.06934)",
    fill: "#006D77"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.02646,
    height: 4.75601,
    rx: 1.01323,
    transform: "matrix(-0.999834 -0.0182052 0.0167307 -0.99986 26.009 4.82031)",
    fill: "#006D77"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04537,
    height: 4.71486,
    rx: 1.02269,
    transform: "matrix(-0.878942 0.476929 -0.44625 -0.894908 15.5884 6.8999)",
    fill: "#006D77"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.10158,
    height: 4.58803,
    rx: 1.05079,
    transform: "matrix(-0.364895 0.931049 -0.919844 -0.392285 7.54126 14.1934)",
    fill: "#006D77"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.11387,
    height: 4.55936,
    rx: 1.05693,
    transform: "matrix(-0.0093926 0.999956 -0.999948 -0.0102206 4.60181 24.6528)",
    fill: "#006D77"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09751,
    height: 4.59744,
    rx: 1.04875,
    transform: "matrix(0.421567 0.906797 -0.892318 0.451408 6.65649 35.6987)",
    fill: "#006D77"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04935,
    height: 4.7061,
    rx: 1.02468,
    transform: "matrix(0.851754 0.523942 -0.492109 0.870533 13.5327 44.2593)",
    fill: "#006D77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup159);
export default __webpack_public_path__ + "static/media/Group 159.25d9e5a25d275c31bfdc9a5402010db9.svg";
export { ForwardRef as ReactComponent };